import jsPDF from 'jspdf';

/**
 * true si el contenido no cabe antes de pageHeight - margin y hay que saltar de página.
 */
export function shouldBreakPage(y: number, requiredSpace: number, pageHeight: number, margin: number): boolean {
  return y + requiredSpace > pageHeight - margin;
}

/**
 * Checker con estado propio: cuando no hay espacio, agrega página y mueve el cursor
 * de yPosition (vía getY/setY) al margen. Usado por los generadores que mantienen
 * yPosition como variable local mutable.
 */
export function makePageSpaceChecker(
  doc: jsPDF,
  pageHeight: number,
  margin: number,
  getY: () => number,
  setY: (y: number) => void
) {
  return (requiredSpace: number): boolean => {
    if (shouldBreakPage(getY(), requiredSpace, pageHeight, margin)) {
      doc.addPage();
      setY(margin);
      return true;
    }
    return false;
  };
}
